import Table from "../../Components/Table";
import StatusHandler from "../../Components/Table/StatusHandler";
import useFetchData from "../../Hooks/useFetchData";
import useTableControls from "../../Hooks/useTableControls";
import { getAdminRideReviews } from "../../Services/Review";
import { format_date, getSerialNumber } from "../../Utils/helpers";
import PageHeader from "../../Components/PageHeader";
import { Link } from "react-router-dom";
import { formatBookingCode } from "../../Utils/bookingCode";

const renderStars = (rating) => {
  const numericRating = Number(rating || 0);
  const filledCount = Math.max(0, Math.min(5, Math.round(numericRating)));

  return (
    <span className="ride-review-stars d-inline-flex align-items-center">
      {[...Array(5)].map((_, index) => {
        const isFilled = index < filledCount;
        return (
          <i
            key={index}
            className={isFilled ? "fas fa-star ride-review-stars__filled" : "far fa-star ride-review-stars__empty"}
            aria-hidden="true"
          />
        );
      })}
      <span className="ride-review-stars__value">{numericRating.toFixed(1)}</span>
    </span>
  );
};

export default function RideReviews() {
  const {
    perPage,
    setPerPage,
    search_string,
    setSearchString,
    from,
    setFrom,
    to,
    setTo,
  } = useTableControls();

  const {
    page,
    setPage,
    isFetching,
    isLoading,
    data,
  } = useFetchData("ride_reviews", getAdminRideReviews, [
    perPage,
    search_string,
    from,
    to,
  ]);

  const docs = data?.data?.data?.docs || [];

  return (
    <div className="app-content content">
      <div className="content-wrapper">
        <div className="content-body">
          <section id="configuration">
            <div className="row">
              <div className="col-12">
                <div className="user-details-wrapper">
                  <PageHeader
                    title="Ride Reviews"
                    subtitle="User and driver ratings after completed bookings"
                  />
                  <Table
                    tableTitles={[
                      "S.No.",
                      "Booking",
                      "Reviewer",
                      "Reviewed",
                      "Rating",
                      "Comment",
                      "Date",
                      "Action",
                    ]}
                    dateFilter
                    showEntries
                    isLoading={isLoading}
                    isFetching={isFetching}
                    data={docs}
                    totalPages={Math.ceil(data?.data?.data?.totalPages || 0)}
                    totalDocs={data?.data?.data?.totalDocs}
                    page={page}
                    setPage={setPage}
                    setSearchString={setSearchString}
                    perPage={perPage}
                    setPerPage={setPerPage}
                    from={from}
                    setFrom={setFrom}
                    to={to}
                    setTo={setTo}
                  >
                    {docs.map((item, index) => {
                      const reviewer = item?.reviewBy;
                      const reviewed = item?.reviewTo;
                      const bookingId = item?.bookingId?._id || item?.bookingId;
                      return (
                        <tr key={item?._id || index}>
                          <td>{getSerialNumber(data?.data?.data, index)}</td>
                          <td>
                            {bookingId ? (
                              <Link to={`/ride-management/ride-details/${bookingId}`} className="fw-bold">
                                {formatBookingCode(item?.bookingId)}
                              </Link>
                            ) : (
                              "—"
                            )}
                          </td>
                          <td>
                            <div className="fw-bold">
                              {[reviewer?.firstName, reviewer?.lastName].filter(Boolean).join(" ") || "—"}
                            </div>
                            <small className="text-muted text-capitalize">{reviewer?.role || "—"}</small>
                          </td>
                          <td>
                            <div className="fw-bold">
                              {[reviewed?.firstName, reviewed?.lastName].filter(Boolean).join(" ") || "—"}
                            </div>
                            <small className="text-muted text-capitalize">{reviewed?.role || "—"}</small>
                          </td>
                          <td>{renderStars(item?.rating)}</td>
                          <td className="ride-review-comment-cell">
                            <span
                              className="ride-review-comment text-muted small"
                              title={item?.message || undefined}
                            >
                              {item?.message || "—"}
                            </span>
                          </td>
                          <td>
                            {item?.createdAt
                              ? format_date(item.createdAt, "MM/DD/YYYY")
                              : "—"}
                          </td>
                          <td>
                            {bookingId ? (
                              <StatusHandler
                                view
                                item={item}
                                redirectUrl={`/ride-management/ride-details/${bookingId}`}
                              />
                            ) : null}
                          </td>
                        </tr>
                      );
                    })}
                  </Table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <style>{`
        .ride-review-stars {
          gap: 2px;
        }
        .ride-review-stars__filled {
          color: #f5a623;
          font-size: 0.95rem;
        }
        .ride-review-stars__empty {
          color: #c8c8c8;
          font-size: 0.95rem;
        }
        .ride-review-stars__value {
          margin-left: 6px;
          color: #1f2937;
          font-weight: 600;
          font-size: 0.85rem;
        }
        .ride-review-comment-cell {
          max-width: 240px;
          width: 240px;
          overflow: hidden;
        }
        .ride-review-comment {
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 1.45;
        }
      `}</style>
    </div>
  );
}
